import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queries } from '../../../../../shared/queries';
import { handleError } from '../../../../ui/err/handleError';
import { showSuccessNotification } from '../../../../ui/notification';
import { AxiosError } from 'axios';
import { AxiosCommonError } from '../../../../../shared/types';
import { prodoqApis } from '../../../../../shared/apis/prodoq/apis';

export default function usePutPermission() {
  const queryClient = useQueryClient();
  return useMutation(prodoqApis.putPermission, {
    onSuccess: () => {
      showSuccessNotification('수정 성공', '권한 수정에 성공하였습니다.');
      queryClient.invalidateQueries({ queryKey: queries.prodoq.permissions._def });
    },
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}
